
import { FeedbackKeys } from '@/i18n/types';

export const feedback: Record<FeedbackKeys, string> = {
  feedback: 'Comentarios',
  submitFeedback: 'Enviar Comentario',
  feedbackTitle: 'Título del Comentario',
  feedbackDescription: 'Descripción del Comentario',
  feedbackType: 'Tipo de Comentario',
  suggestion: 'Sugerencia',
  bugReport: 'Reporte de Error',
  question: 'Pregunta',
  feedbackSubmitted: 'Comentario Enviado',
  thanksForFeedback: 'Gracias por tu comentario. Ha sido enviado a info@planwisenow.io',
  improvement: 'Mejora',
  comment: 'Comentario',
  error: 'Error',
  feedbackHistory: 'Tu Historial de Feedback',
  feedbackIntro: 'Comparte tus sugerencias, reporta errores o haz preguntas para ayudarnos a mejorar.',
  feedbackTitlePlaceholder: 'Escribe un título breve',
  feedbackDescriptionPlaceholder: 'Describe tu sugerencia o comentario en detalle',
  selectType: 'Selecciona un tipo',
  submitting: 'Enviando...',
  mustBeLoggedIn: 'Debes iniciar sesión para enviar feedback.',
  loginToSubmitFeedback: 'Debes iniciar sesión para enviar feedback.',
  loginToViewHistory: 'Inicia sesión para ver tu historial de feedback',
  noFeedbackYet: 'No has enviado ningún feedback todavía.',
  errorLoadingFeedback: 'Error al cargar el feedback. Por favor, intenta nuevamente.',
  tryAgain: 'Por favor intenta de nuevo.',
  loading: 'Cargando...',
  pending: 'Pendiente',
  reviewed: 'Revisado',
  implemented: 'Implementado',
  allFeedbackSentTo: 'Todos los comentarios se envían a info@planwisenow.io para su revisión.',
  couldNotSubmitFeedback: 'No se pudo enviar tu feedback. Por favor, intenta nuevamente.',
  titleMinLength: 'El título debe tener al menos 5 caracteres',
  descriptionMinLength: 'La descripción debe tener al menos 10 caracteres',
};
